<template>
  <el-dialog
    title="半自动二次认领"
    :visible.sync="dialogVisible"
    width="80%"
    class="secondClaimDialog"
    id="secondClaimDialog"
    @close="closeDialog"
  >
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @contractNoChange="contractNoChange"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        column-min-width="120"
        :loading="load"
        :auto-resize="true"
        :data="tableData"
        :max-height="tableHeight"
        :columns="columnList"
        :toolbar="{ custom: true }"
        :custom-config="{ storage: true }"
        :edit-rules="rules"
        :edit-config="isEdit ? { trigger: 'click', mode: 'row' } : ''"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        show-footer
        :footer-method="footerMethod"
      >
      </vxe-grid>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{
        this.$t('receivablesManageList.button.cancel')
      }}</el-button>
      <el-button :disabled="!isEdit" type="primary" @click="save">{{
        this.$t('receivablesManageList.button.determine')
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import SiruiSearch from '@/components/SiruiSearch';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  import API from '@/api/capitalCenter/receivablesManage';
  export default {
    props: ['departmentList'],
    data() {
      return {
        tableHeight: document.body.clientHeight - 400 + 'px' || 0,
        dialogVisible: false,
        load: false,
        tableData: [],
        currency: null,
        sumObj: {},
        query: {
          registerId: null,
          firstClaimId: null,
          contractBusinessDepartment: null,
          contractBusinessDepartmentName: null,
          contractCreateDate: null,
          customerNo: null,
          customerName: null,
          //receivedType: null,
          contractCategory: null,
          isCreditsale: null,
          ladingNo: null,
          contractNo: null,
        },
        rowObj: {
          registerId: null,
          receivedType: null,
          receivedDetailType: '01',
          projectCode: null,
          projectName: null,
          settlementNo: null,
          contractBusinessDepartment: null,
          contractBusinessDepartmentName: null,
          contractNo: null,
          isCreditsale: '0', // 是否赊销
          ladingNo: null, // 提单号
          ladingTotalAmount: 0, // 提单金额
          contractTotalAmount: 0, // 合同金额
          totalQuantity: 0, // 合同数量
          contractCreateDate: null, // 合同创建日期
          invoiceAmount: 0,
          ladingAmount: 0, // 已开提单总金额（B）
          registerAmount: 0, //已认领总金额
          ladingRegisterAmount: 0, // 已认领提单金额
          ASubC: 0,
          BSubC: 0,
          originProformaInvoiceAmount: 0,
          originReceiveMoneyAmount: 0,
          originDomesticBankDeductFee: 0,
          originForeignBankDeductFee: 0,
        },
        flagUnClaimedAmount: 0,
        secondUnClaimAmount: {},
        secondTotalAmount: {},
        receiptClaimMode: null, // 判断收款认领模式 C-合同,L-提单
        receivedTypeOptions: [],
      };
    },
    components: {
      SiruiSearch,
      // inputNumberAd,
    },
    computed: {
      searchColumns() {
        return [
          {
            // 部门
            name: this.$t('receivablesManageDialog.secondClaim.contractBusinessDepartment'),
            prop: 'contractBusinessDepartmentName',
            type: 'input',
            disabled: true,
          },
          /* {
            // 收款类别
            name: this.$t('receivablesManageDialog.secondClaim.receivedType'),
            prop: 'receivedType',
            type: 'select',
            options: this.receivedTypeOptions,
            disabled: true,
          },
          {
            // 是否赊销
            name: this.$t('receivablesManageDialog.secondClaim.isCreditsale'),
            prop: 'isCreditsale',
            type: 'dict',
            dictType: 'yes-no',
          }, */
          {
            // 合同创建日期
            name: this.$t('receivablesManageDialog.secondClaim.contractCreateDate'),
            prop: 'contractCreateDate',
            type: 'date',
          },
          {
            // 客户
            name: this.$t('receivablesManageDialog.secondClaim.customerNo'),
            prop: 'customerName',
            type: 'input',
            disabled: true,
          },
          ...(this.receiptClaimMode == 'L' && this.query.contractCategory == 'sales'
            ? [
                {
                  // 提单号（粮化部）
                  prop: 'ladingNo',
                  name: '提单号',
                  type: 'input',
                  placeholder: '请选择提单号',
                },
              ]
            : []),
          {
            //销售合同号
            prop: 'contractNo',
            name: '销售合同号',
            type: 'searchTableSpec',
            searchType: 'contract',
            isMultiple: true,
            extraData: {
              customerNo: this.query.customerNo,
              contractBusinessDepartmentNo: this.query.contractBusinessDepartment,
            },
            placeholder: '请选择销售合同号',
            changeMethod: 'contractNoChange',
          },
        ];
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50, fixed: 'left' },
          {
            // 序号
            type: 'seq',
            width: 90,
            title: this.$t('receivablesManage.receivablesClaimInfo.seq'),
            fixed: 'left',
          },
          {
            // 收款细类
            field: 'receivedDetailType',
            title: this.$t('receivablesManageDialog.secondClaim.receivedDetailType'),
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('receivedDetailType'),
              props: {
                clearable: true,
                filterable: true,
              },
              events: {
                change: (obj) =>
                  this.updateCol(obj.row, obj.row['receivedDetailType'], 'receivedDetailType'),
              },
            },
            dictType: 'receivedDetailType',
          },
          {
            //项目编号
            field: 'projectCode',
            title: this.$t('receivablesManageDialog.secondClaim.projectCode'),
          },
          {
            //结算单
            field: 'settlementNo',
            title: this.$t('receivablesManageDialog.secondClaim.settlementNo'),
            width: 120,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.settlementNo}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="receivableSettlement"
                      isMultiple={true}
                      currentValue={row['settlementNo']}
                      checkRowKeys={[row['settlementNo']]}
                      extraData={{
                        settlementStatus: '04',
                      }}
                      onInput={(val) => this.chooseTable(val, row, 'settlementNo')}
                    ></search-table>,
                  ];
                },
              },
            },
          },
          ...(this.receiptClaimMode == 'L' && this.query.contractCategory == 'sales'
            ? [
                {
                  // 提单号（粮化部）
                  field: 'ladingNo',
                  title: this.$t('receivablesManageDialog.secondClaim.ladingNo'),
                },
              ]
            : []),
          {
            // 销售合同管理号
            field: 'contractNo',
            // title: this.query.contractCategory=='sales'?
            // this.$t('receivablesManageDialog.secondClaim.salesContractNo'):
            // this.$t('receivablesManageDialog.secondClaim.purchaseContractNo'),
            title: this.$t('receivablesManageDialog.secondClaim.salesContractNo'),
          },
          {
            // 经办部门
            field: 'contractBusinessDepartmentName',
            title: this.$t('receivablesManageDialog.secondClaim.contractBusinessDepartment'),
          },
          {
            // 合同金额
            field: 'contractTotalAmount',
            title: this.$t('receivablesManageDialog.secondClaim.contractTotalAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.contractTotalAmount)}</span>,
                ];
              },
            },
          },
          /* ...(this.receiptClaimMode == 'L' && this.query.contractCategory == 'sales'
            ? [
                {
                  // 提单金额
                  field: 'ladingTotalAmount',
                  title:
                    this.$t('receivablesManageDialog.secondClaim.ladingTotalAmount') +
                    '(' +
                    this.currency +
                    ')',
                  slots: {
                    default: ({ row }) => {
                      return [
                        <span>{this.$baseRequest.formatTableColumn(row.ladingTotalAmount)}</span>,
                      ];
                    },
                  },
                },
              ]
            : []), */
          /*  {
            // 合同创建日期
            field: 'contractCreateDate',
            title: this.$t('receivablesManageDialog.secondClaim.contractCreateDate'),
          }, */
          {
            // 已开发票总金额
            field: 'invoiceAmount',
            title: this.$t('receivablesManageDialog.secondClaim.invoiceAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.invoiceAmount)}</span>];
              },
            },
          },
          /* ...(this.receiptClaimMode == 'L' && this.query.contractCategory == 'sales'
            ? [
                {
                  // 已开提单总金额（B）
                  field: 'ladingAmount',
                  title:
                    this.$t('receivablesManageDialog.secondClaim.ladingAmount') +
                    '(' +
                    this.currency +
                    ')',
                  slots: {
                    default: ({ row }) => {
                      return [<span>{this.$baseRequest.formatTableColumn(row.ladingAmount)}</span>];
                    },
                  },
                },
                {
                  // 已认领提单金额（L）
                  field: 'ladingRegisterAmount',
                  title:
                    this.$t('receivablesManageDialog.secondClaim.ladingRegisterAmount') +
                    '(' +
                    this.currency +
                    ')',
                  slots: {
                    default: ({ row }) => {
                      return [
                        <span>
                          {this.$baseRequest.formatTableColumn(row.ladingRegisterAmount)}
                        </span>,
                      ];
                    },
                  },
                },
                {
                  // 未认领提单金额（L）
                  field: 'unladingRegisterAmount',
                  title:
                    this.$t('receivablesManageDialog.secondClaim.unladingRegisterAmount') +
                    '(' +
                    this.currency +
                    ')',
                  slots: {
                    default: ({ row }) => {
                      return [
                        <span>
                          {this.$baseRequest.formatTableColumn(row.unladingRegisterAmount)}
                        </span>,
                      ];
                    },
                  },
                },
              ]
            : []), */
          {
            // 已认领总金额
            field: 'registerAmount',
            title: this.$t('receivablesManageDialog.secondClaim.registerAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.registerAmount)}</span>];
              },
            },
          },
          {
            // A-C未认领金额
            field: 'ASubC',
            title: this.$t('receivablesManageDialog.secondClaim.ASubC'),
          },
          {
            // 收款金额
            field: 'originReceiveMoneyAmount',
            fixed: 'right',
            title: this.$t('receivablesManageDialog.secondClaim.originReceiveMoneyAmount'),
            // 二次认领详情-形式发票金额不存在时，形式发票金额禁止填写，收款金额手动填写
            ...(this.amountName == 'originReceiveMoneyAmount'
              ? {
                  editRender: {
                    name: 'ElInput',
                    props: {
                      clearable: true,
                    },
                  },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.originReceiveMoneyAmount}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <input-number-ad
                          value={row.originReceiveMoneyAmount}
                          max={999999999.99}
                          min={0}
                          precision={2}
                          onChange={() => this.verifyAmount(row)}
                          onInput={(val) => this.chooseTable(val, row, 'originReceiveMoneyAmount')}
                        ></input-number-ad>,
                      ];
                    },
                  },
                }
              : {}),
          },
        ];
      },
      // 原币基准值名称(当一次认领存在形式发票金额时，以形式发票金额为准，若不存在时，已收款金额为准)
      amountName() {
        return this.secondTotalAmount.originProformaInvoiceAmount
          ? 'originProformaInvoiceAmount'
          : 'originReceiveMoneyAmount';
      },
      // 所需计算的原币key
      needCalcOriginAmountProps() {
        let arr = [
          'originDomesticBankDeductFee',
          'originForeignBankDeductFee',
          'originReceiveMoneyAmount',
        ];
        /* if (this.amountName == 'originProformaInvoiceAmount') { // 形式发票金额
        arr = [
          'originReceiveMoneyAmount',
          ...arr,
        ];
      } */
        return arr;
      },
      isEdit() {
        if (
          (this.amountName == 'originProformaInvoiceAmount' &&
            !this.secondUnClaimAmount.originProformaInvoiceAmount) ||
          (this.amountName == 'originReceiveMoneyAmount' &&
            !this.secondUnClaimAmount.originReceiveMoneyAmount)
        ) {
          return false;
        } else {
          return true;
        }
      },
      rules() {
        return this.amountName == 'originProformaInvoiceAmount'
          ? {
              originProformaInvoiceAmount: [
                {
                  required: true,
                  message: this.$t(
                    'receivablesManage.placeholder.originProformaInvoiceAmountPlaceholder'
                  ),
                  trigger: ['blur', 'change'],
                },
              ],
              receivedDetailType: [
                {
                  required: true,
                  message: '收款细类必填',
                  trigger: ['blur', 'change'],
                },
              ],
            }
          : {
              originReceiveMoneyAmount: [
                {
                  required: true,
                  message: this.$t(
                    'receivablesManage.placeholder.originReceiveMoneyAmountPlaceholder'
                  ),
                  trigger: ['blur', 'change'],
                },
              ],
              receivedDetailType: [
                {
                  required: true,
                  message: '收款细类必填',
                  trigger: ['blur', 'change'],
                },
              ],
            };
      },
    },
    mounted() {
      this.getReceivedTypeOptions();
    },
    methods: {
      openDialog(flag, item) {
        // 打开
        this.dialogVisible = flag;
        this.query.registerId = item.registerId;
        this.query.firstClaimId = item.id;
        this.query.contractBusinessDepartment = item.claimDepartmentNo;
        this.query.contractBusinessDepartmentName = item.claimDepartmentName;
        this.query.contractCategory = item.customerNo ? 'sales' : 'purchase';
        this.query.customerNo = item.customerNo ? item.customerNo : item.claimPartnerNo;
        this.query.customerName = item.customerName ? item.customerName : item.claimPartnerName;
        this.query.receivedType = item.receivedType;
        this.receiptClaimMode = this.departmentList.find(
          (i) => i.value == item.claimDepartmentNo
        ).receiptClaimMode;
        this.currency = item.currency;
        this.secondTotalAmount = item.secondTotalAmount;
        this.getData();
      },
      getReceivedTypeOptions() {
        let options = this.$baseRequest.getDictListMapByType('receivedType');
        options.push({ label: '供应商保证金', value: 'RT18' });
        this.receivedTypeOptions = options;
      },
      closeDialog() {
        // 关闭
        this.dialogVisible = false;
        Object.keys(this.query).map((item) => {
          this.query[item] = null;
        });
        this.secondUnClaimAmount = {};
        this.tableData = [];
      },
      async getData() {
        // 获取合同信息
        this.load = true;
        let res = await this.$axios.post(API.QUERY_COLLECTIONCLAIM_CONTRACTFORSECOND, this.query);
        if (res) {
          this.load = false;
          if (res.data.code == 0) {
            if (res.data.data) {
              // 获取二次认领所选部门的未认领金额
              this.secondUnClaimAmount = res.data.data.unclaimedAmount;
              // 获取合同
              this.tableData = res.data.data.fundCollectionContractClaims;
              this.tableData.map((item) => {
                item.registerId = this.query.registerId;
                item.contractBusinessDepartment = this.query.contractBusinessDepartment;
                item.contractBusinessDepartmentName = this.query.contractBusinessDepartmentName;
                item.receivedType = this.query.receivedType;
                Object.keys(this.rowObj).map((i) => {
                  // 不存在的key赋值
                  if (!item[i]) {
                    item[i] = this.rowObj[i];
                  }
                });
                // 未已认领提单金额（L）
                item.unladingRegisterAmount = this.$cal.calCommon(
                  item.ladingTotalAmount,
                  item.ladingRegisterAmount,
                  '-',
                  'amount'
                );
                // A-C
                item.ASubC = this.$cal.calCommon(
                  item.invoiceAmount,
                  item.registerAmount,
                  '-',
                  'amount'
                );
                // B-C
                item.BSubC = this.$cal.calCommon(
                  item.ladingAmount,
                  item.registerAmount,
                  '-',
                  'amount'
                );
              });
              this.autoCalc();
            } else {
              this.tableData = null;
            }
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      async save() {
        // 保存
        let contractClaims = await this.exportChildData();
        if (contractClaims) {
          if (this.flagUnClaimedAmount < 0) {
            return this.$message({
              showClose: true,
              message: this.$t('receivablesManage.message.calcInfo'),
              type: 'error',
            });
          }
          this.loading.startLoading();
          this.$axios
            .post(API.SAVE_COLLECTIONCLAIM_SECONDBYCONTRACT, {
              contractClaims,
              overAmountVerification: 'Y',
              firstClaimId: this.query.firstClaimId,
            })
            .then((res) => {
              this.loading.endLoading();
              if (res.data.code == 0) {
                this.$message({ showClose: true, type: 'success', message: res.data.msg });
                this.$emit('getAllData', this.query.registerId);
                this.closeDialog();
              } else {
                if (res.data.msg.indexOf('ERROR50001') != -1) {
                  this.$confirmAction(
                    res.data.msg.replace('ERROR50001', ''),
                    this.$t('receivablesManage.message.save')
                  )
                    .then(() => {
                      this.loading.startLoading();
                      this.$axios
                        .post(API.SAVE_COLLECTIONCLAIM_SECONDBYCONTRACT, {
                          contractClaims,
                          overAmountVerification: 'N',
                          firstClaimId: this.query.firstClaimId,
                        })
                        .then((res) => {
                          this.loading.endLoading();
                          if (res.data.code == 0) {
                            this.$message({
                              showClose: true,
                              type: 'success',
                              message: res.data.msg,
                            });
                            this.$emit('getAllData', this.query.registerId);
                            this.closeDialog();
                          } else {
                            this.$message({
                              showClose: true,
                              type: 'error',
                              message: res.data.msg,
                            });
                          }
                        });
                    })
                    .catch(() => {
                      this.$message({
                        showClose: true,
                        type: 'info',
                        message: this.$t('confirm.deleteCancelled'),
                      });
                    });
                } else {
                  this.$message({ showClose: true, type: 'error', message: res.data.msg });
                }
              }
            });
        }
      },
      contractNoChange(val) {
        // 切换
        let res = val.val;
        if (res && res.length > 0) {
          this.query.contractNo = res[0].contractNo;
        } else {
          this.query.contractNo = null;
        }
      },
      // 在值发生改变时更新数据
      updateData() {
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      // 表尾合计
      footerMethod({ columns }) {
        let hasChktableData = this.$refs.table.getCheckboxRecords();
        if (hasChktableData.length > 0) {
          let returnAmountProps = [
            'originProformaInvoiceAmount',
            'originReceiveMoneyAmount',
            'originDomesticBankDeductFee',
            'originForeignBankDeductFee',
          ];
          return [
            columns.map((column, columnIndex) => {
              if (columnIndex === 1) {
                return this.$t('receivablesManageDialog.secondClaim.hasClaim');
              }
              if (returnAmountProps.includes(column.property)) {
                let subtrahend = 0;
                for (let i = 0; i < hasChktableData.length; i++) {
                  subtrahend = this.$cal.calCommon(
                    hasChktableData[i][column.property],
                    subtrahend,
                    '+'
                  );
                }
                this.sumObj[column.property] = subtrahend;
                return this.$baseRequest.formatTableColumn(subtrahend);
              }
              return null;
            }),
            columns.map((column, columnIndex) => {
              if (columnIndex === 1) {
                return this.$t('receivablesManageDialog.secondClaim.noClaim');
              }
              if (returnAmountProps.includes(column.property)) {
                let minuend = this.secondUnClaimAmount[column.property];
                let subtrahend = 0;
                for (let i = 0; i < hasChktableData.length; i++) {
                  subtrahend = this.$cal.calCommon(
                    hasChktableData[i][column.property],
                    subtrahend,
                    '+'
                  );
                }
                if (column.property == this.amountName) {
                  this.flagUnClaimedAmount = this.$cal.calCommon(minuend, subtrahend, '-');
                }
                return this.$baseRequest.formatTableColumn(
                  this.$cal.calCommon(minuend, subtrahend, '-')
                );
              }
              return null;
            }),
          ];
        } else {
          return [];
        }
      },
      // 计算原币
      calcOriginAmount(amountRow, totalAmountRow, returnTotalAmount) {
        // 当前行标识金额 * 最终所需返回金额的总额 / 标识金额总额
        let calcAmount1 = this.$cal.calCommon(amountRow, returnTotalAmount, '*');
        let calcAmount2 = this.$cal.calCommon(calcAmount1, totalAmountRow, '/', 'amount');
        return calcAmount2;
      },
      // 自动计算金额
      autoCalc() {
        let idxs = [];
        // 自动勾选复选框数组
        let rowIdxArr = [];
        // 当前人二次认领未认领行金额
        let unClaimedAmountRow = this.secondUnClaimAmount[this.amountName];
        this.tableData.map((item, index) => {
          let unClaimedForContract;
          if (this.receiptClaimMode == 'L' && this.query.contractCategory == 'sales') {
            if (item.ladingTotalAmount < item.ladingRegisterAmount) {
              unClaimedForContract = 0;
            } else {
              unClaimedForContract = this.$cal.calCommon(
                item.ladingTotalAmount,
                item.ladingRegisterAmount,
                '-',
                'amount'
              );
            }
          } else {
            // 当前人合同未认领金额 (这边需要改)
            if (item.contractTotalAmount < item.registerAmount) {
              unClaimedForContract = 0;
            } else {
              unClaimedForContract = this.$cal.calCommon(
                item.contractTotalAmount,
                item.registerAmount,
                '-',
                'amount'
              );
            }
          }
          if (index != 0) {
            unClaimedAmountRow = this.$cal.calCommon(
              unClaimedAmountRow,
              this.tableData[index - 1][this.amountName],
              '-',
              'amount'
            );
          }
          if (unClaimedAmountRow > 0) {
            if (unClaimedAmountRow > unClaimedForContract) {
              item[this.amountName] = unClaimedForContract;
            } else {
              item[this.amountName] = unClaimedAmountRow;
            }
            if (unClaimedForContract != 0) {
              idxs.push(index);
              rowIdxArr.push(this.tableData[index]);
            }
          }
        });
        this.autoCalcOtherOrigin(idxs);
        this.setCheckboxRow(rowIdxArr);
        this.backOff();
        // 实时更新数据
        this.updateData();
        // 实时合计
        this.updateFooterEvent();
      },
      autoCalcOtherOrigin(idxs) {
        idxs.map((i) => {
          this.autoCalcOtherOriginItem(this.tableData[i]);
        });
      },
      // 自动计算每行其他原币金额
      autoCalcOtherOriginItem(row) {
        this.needCalcOriginAmountProps.map((i) => {
          if (i == 'originReceiveMoneyAmount' && row['receivedDetailType'] == '01') {
            //纯货款时，本次认领金额为未认领金额*（1-税点）
            row[i] = this.$cal.calCommon(row.ASubC, 1 - row.taxRate, '*', 'amount');
          } else {
            row[i] = this.calcOriginAmount(
              row[this.amountName],
              this.secondTotalAmount[this.amountName],
              this.secondTotalAmount[i]
            );
          }
        });
      },
      //JSX更新字段
      updateCol(row, val, type) {
        row[type] = val;
        if (type == 'receivedDetailType') {
          this.autoCalc();
        }
      },
      // 金额校验
      verifyAmount() {
        // 合计金额不能超过总金额
        if (this.sumObj[this.amountName] > this.secondUnClaimAmount[this.amountName]) {
          this.$message({
            showClose: true,
            message: this.$t('receivablesManage.message.calcInfo'),
            type: 'error',
          });
        }
      },
      // 金额倒扣
      backOff() {
        this.$nextTick(() => {
          // 当合计金额等于总金额时，最后一条数据其他计算所得金额倒扣
          if (this.sumObj[this.amountName] == this.secondUnClaimAmount[this.amountName]) {
            let hasChktableData = this.$refs.table.getCheckboxRecords();
            let len = hasChktableData.length;
            if (len > 0) {
              this.needCalcOriginAmountProps.map((item) => {
                let itemAmount = hasChktableData[len - 1][item];
                let itemAmountSum = this.sumObj[item];
                hasChktableData[len - 1][item] = this.$cal.calCommon(
                  this.$cal.calCommon(this.secondUnClaimAmount[item], itemAmountSum, '-'),
                  itemAmount,
                  '+',
                  'amount'
                );
              });
            }
          }
          // 更新数据
          this.updateData();
        });
      },
      // 二次认领赋值
      chooseTable(val, row, prop) {
        row[prop] = val;
        if (prop == 'projectCode') {
          if (val && val.length > 0) {
            row['projectName'] = val[0].projectName;
            row['projectCode'] = val[0].projectCode;
          } else {
            row['projectName'] = null;
            row['projectCode'] = null;
          }
        }
        if (prop == 'settlementNo') {
          if (val && val.length > 0) {
            row['settlementNo'] = val[0].receivableSettlementNo;
          } else {
            row['settlementNo'] = null;
          }
        }
        if (prop != 'originReceiveMoneyAmount') {
          // 自动计算每行其他原币金额
          this.autoCalcOtherOriginItem(row);
        }
        // 自动计算每行其他原币金额
        //this.autoCalcOtherOriginItem(row);
        // 金额倒扣
        this.backOff();
        // 实时更新数据
        this.updateData();
        // 实时合计
        this.updateFooterEvent();
      },
      // 在值发生改变时更新表尾合计
      updateFooterEvent() {
        let xTable = this.$refs.table;
        xTable.updateFooter();
      },
      // 设置默认选中
      setCheckboxRow(rowIdxArr) {
        let xTable = this.$refs.table;
        xTable.setCheckboxRow(rowIdxArr, true);
      },
      // 选中事件
      handleSelectionChange(val) {
        this.updateFooterEvent();
        this.verifyAmount(val.row);
      },
      // 重置
      resetBtnClick() {
        this.getData();
      },
      searchBtnClick() {
        if (!this.query.contractBusinessDepartment) {
          return this.tips('noSelDepart', 'error');
        }
        this.resetBtnClick();
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManageDialog.message.${info}`),
          type: type,
        });
      },
      // 返回数据
      exportChildData() {
        let hasChktableData = [];
        this.$refs.table.getCheckboxRecords().map((item, index) => {
          hasChktableData.push({ ...item, sortNo: index });
        });
        // 点击提交，走校验
        if (hasChktableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              resolve(hasChktableData);
            });
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  ::v-deep.secondClaimDialog {
    // text-align: center;
    .el-dialog__body {
      padding: 30px 100px 12px 100px;
      max-height: fit-content !important;
      .el-select,
      .el-input {
        width: 100%;
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
</style>
